import React, {useState} from "react";
import useListContext from "../../tools/useListContext";
import {useModal} from "../../tools/useModal";
import {StoreHouseRepository} from "../../repository/AdminDashboard/storehouse-Repository";
import useDebounce from "../../tools/useDebounce";
import toast from "react-hot-toast";
import {showToastByIsSuccess} from "../../tools/tools";

const StorehouseContext = React.createContext();


export function StorehouseProvider({children}) {
    const {
        handleUpdateListState, listState, changePage, onSearchBtnClick,
    } = useListContext(getItems)

    const {closeModal, openModal, modalState} = useModal();

    const [addDeviceState, setAddDeviceState] = useState({
        searchLoading: false,
        searchQueryModel: "",
        findModels: [],
        brokerPassword: "",
        selectedSerialNumber: "",
        addDeviceLoading: false
    })

    const [activateDeviceState, setActivateDeviceState] = useState({
        warrantyNumber: "",
        searchQueryWarranty: "",
        searchLoading: false,

        findWarranty: [],
        factorNumber: "",
        buttonLoading: false
    })

    const addDeviceStateUpdate = (key, value) => {
        setAddDeviceState(prevState => ({...prevState, [key]: value}))
    }
    const updateDeviceStatus = (key, value) => {
        setActivateDeviceState(prevState => ({...prevState, [key]: value}))
    }

    const generateBrokerPassword = () => {
        return Math.random().toString(36).slice(6) + Math.random().toString(36).slice(6);
    };

    async function getItems() {
        handleUpdateListState("loading", true)
        const response = await StoreHouseRepository.getStoreHouse(listState.searchQuery, listState.pageNumber);
        handleUpdateListState("loading", false)
        handleUpdateListState("list", response.StoreHouseList)
        handleUpdateListState("countAll", response.countAllPages)

    }


    async function deleteStorehouseDevice() {

        const response = await StoreHouseRepository.delete(modalState.selectedItem.id);
        if (response.success) {
            toast.success(response.message)
            await getItems()
            closeModal()
        } else {
            toast.error(response.message)
        }
    }


    async function searchDeviceModelsRequest(query) {
        const response = await StoreHouseRepository.model(query);
        if (response.code === 1) {
            addDeviceStateUpdate("findModels", response.model)

        }
    }

    async function searchDeviceWarrantyRequest(query) {
        const response = await StoreHouseRepository.granti(query);
        if (response.code === 1) {
            updateDeviceStatus("findWarranty", response.granti)

        }
    }

    async function searchModels(props) {

        if (props.state.search.length > 2 && addDeviceState.searchQueryModel !== props.state.search) {
            addDeviceStateUpdate("searchLoading", true)
            addDeviceStateUpdate("searchQueryModel", props.state.search)
        }

    }

    async function searchWarranty(props) {
        if (props.state.search.length > 2 && activateDeviceState.searchQueryWarranty !== props.state.search) {
            updateDeviceStatus("searchLoading", true)
            updateDeviceStatus("searchQueryWarranty", props.state.search)
        }
    }

    async function addDeviceToStorehouse(data) {
        const body = {
            model: data.modelId,
            brokerPass: data.broker,
        }
        addDeviceStateUpdate("addDeviceLoading", true)
        const response = await StoreHouseRepository.add(body);
        addDeviceStateUpdate("addDeviceLoading", false)
        if (response.success) {
            await getItems()
            toast.success(response.message)
            closeModal()
        } else {
            toast.error(response.message)
        }


    }

    /*Callback for Editing Device Password*/
    async function editDevice(id, password) {
        const response = await StoreHouseRepository.sendpass({
            id: id,
            pass: password

        });
        showToastByIsSuccess(response.success, response.message)
        closeModal()
    }

    async function activeDevice() {

        const response = await StoreHouseRepository.donactive({
            garanti: activateDeviceState.warrantyNumber,
            order: "",
            factorNum: activateDeviceState.factorNumber,
            serialNumber: modalState.selectedItem.serialNumber,
        });

        if (response.success) {
            updateDeviceStatus("warrantyNumber", "")
            updateDeviceStatus("factorNumber", "")
            await getItems()
            closeModal()
        }

        showToastByIsSuccess(response.success, response.message)

    }

    useDebounce(
        async () => {
            await searchDeviceModelsRequest(addDeviceState.searchQueryModel)
            addDeviceStateUpdate("searchLoading", false)
        },
        2000,
        [addDeviceState.searchQueryModel]
    );

    useDebounce(
        async () => {
            await searchDeviceWarrantyRequest(activateDeviceState.searchQueryWarranty)
            updateDeviceStatus("searchLoading", false)
        },
        2000,
        [activateDeviceState.searchQueryWarranty]
    );
    return (<StorehouseContext.Provider value={{
        deleteStorehouseDevice,
        changePage,
        onSearchBtnClick,
        listState,
        closeModal,
        openModal,
        modalState,
        addDeviceStateUpdate,
        addDeviceState,
        searchModels,
        generateBrokerPassword,
        addDeviceToStorehouse,
        updateDeviceStatus,
        activateDeviceState,
        editDevice,
        searchWarranty,
        activeDevice
    }}>
        {children}
    </StorehouseContext.Provider>)
}

export function useStorehouseContext() {
    return React.useContext(StorehouseContext);
}
